<template>
  <div>
    <span v-if="showFlag==1">
      <span v-if="caseTM" @click="openTrain(caseID)" class="addStyle pointer">
        <a style="color:#2196f3;">恢复训练</a>
      </span>
      <span v-else @click="openTrain(caseID)" class="addStyle pointer">现场训练</span>
    </span>
    <mu-raised-button v-else label="现场训练" @click="openTrain(caseID)" style="border-radius:40px;" primary />
    <!-- <trainModal v-if="showTrain" :caseId="caseID" @close="closeTrain" @submitData="submitCase"></trainModal> -->
    <trainModal2 ref="supervisedTrainDialog" v-if="showTrain" :caseId="caseID" @close="closeTrain" @submitData="submitCase"></trainModal2>
    <timeModalSelect ref="timesupervisedTrainDialog" v-if="showTimeTrain" :caseId="caseID" @close="closeTrain"></timeModalSelect>
    <trainCronSave v-if="saveGame" :rest.sync="rest" :gameData="gameData" :gameFlag="1" :caseId="caseID" @updateScore="getGameScore" @close="saveGame=false" @restart="over"></trainCronSave>
    <gameOver v-if="showOver" :score="gameScore" :gameFlag="flag" @restart="restartTrain" @close="closeGame "></gameOver>
    <zeroLeft v-if="showTimeError" @close="showTimeError=false"></zeroLeft>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  import trainModal from '../../service/case/trainRecord/trainModal.vue'
  import trainModal2 from '../../service/train/trainModal2'
  import trainCronSave from '../trainCronSave.vue'
  import gameOver from '../gameOver.vue'
  import timeModalSelect from '../../service/times/timeModalSelect2.vue'
  import zeroLeft from '../timer/zeroLeft.vue'

  export default ({
    props:["caseID","caseTM","showFlag"],
    data() {
      return{
        saveGame: false,   // 打开1.0游戏
        showTrain: false,  // 显示现场训练
        showTimeTrain: false, // 显示训练次数功能
        showOver: false,
        showTimeError: false,
        gameData: '',       // 游戏数据
        gameScore: {},
        flag:2,
        rest:0,//再练一次时保存训练等级的flag
      }
    },
    computed:{
      trainCounts(){
        return this.$store.state.trainCounts;
      },
      showCount(){
        return this.$store.state.showCount;
      }
    },
    components:{
      trainModal,
      trainCronSave,
      gameOver,
      timeModalSelect,
      zeroLeft,
      trainModal2,
    },
    methods : {
      submitCase: function(res) {
        if (res.length == 0) {
          alert('請選擇訓練項目');
        } else {
          this.gameData = res;
          this.saveGame = true;
          this.showTrain = false;
        }
      },
      getGameScore: function(res,name,lscore){
        console.log(name)
        this.showOver = true;
        this.saveGame = false;
        this.gameScore = res;
        this.gameScore['name'] = name;
        this.gameScore['lastScore'] = lscore;
        this.flag = 1; //进入认知游戏小结页
      },
      closeGame: function(){
        this.showOver = false;
        this.showTrain = true;
        console.log(this.showTrain)
      },
      openTrain:function(){
        if(this.showCount){
          if(this.trainCounts>0){
            Vue.http({
              method: 'GET',
              url:'/api/Train/infoTM',
              params: {
                'patient_uuid': this.caseID,
              }
            })
            .then((res)=>{
              if(res.data.data.status && res.data.data.status != 10){
                this.$router.push({path: '/trainTime/',query:{selectTrain:res.data.data.checked,caseId: this.caseID, time: res.data.data.time_left}});
              } else {
                this.showTimeTrain=true;
                this.$nextTick(() => { this.$refs.timesupervisedTrainDialog.show()})
              }
            })
          } else {
            this.showTimeError = true;
          }
        } else {
          this.$nextTick(() => { this.$refs.supervisedTrainDialog.show() })
          this.showTrain=true;
          /*解决开始训练悬浮层覆盖bug*/
          $(".controlOverflow").css("overflow","");
        }
        console.log(this.showTrain);
      },
      // 再练习一次
      restartTrain: function(rest){
        this.showOver = false;
        this.saveGame = true;
        this.rest = rest;
      },
      closeTrain:function(){
        if(this.showCount){
          this.showTimeTrain=false;
        } else {
          this.showTrain=false;
          $(".controlOverflow").css("overflow","auto");
        }
      },
      over(val){
        this.saveGame = false;
        this.showOver = true;
        this.flag = 2;
        this.gameScore = val;
      }
    }
  })
</script>

<style scoped>
.addStyle{
  font-weight:bold;
  text-decoration:underline;
}

</style>



// WEBPACK FOOTER //
// trainScene.vue?47ba6517